import firebase from 'firebase'
import 'firebase/firestore'

const fb = firebase.initializeApp({
  apiKey: "AIzaSyCBOjgqQhtz397e0of2q9Q-LIxqf3-er-g",
  authDomain: "lucident-app.firebaseapp.com",
  databaseURL: "https://lucident-app.firebaseio.com",
  projectId: "lucident-app",
  storageBucket: "",
  messagingSenderId: "125019906150",
  appId: "1:125019906150:web:7b1ffad1e68efa6c640da7"
})

export const firestoreInit = fb.firestore();
export let authorization = fb;
export const db = fb.database();

// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { TimeStamp, GeoPoint } = firebase.firestore
export { TimeStamp, GeoPoint }

// if using Firebase JS SDK < 5.8.0



//////////////////
// WEBPACK FOOTER
// ./config/firebase.js
// module id = null
// module chunks = 